import { useCampaignPlannerContext } from '@/dashboards/CampaignPlanner/hooks/useCampaignPlannerContext';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { DateFormat, formatDate } from '@/utils/dateUtils';
import { formatNumber } from '@/utils/numberUtils';
import { Button, Modal, Textarea, Typography } from '@analytical-alley/ui';
import { useMemo, useState } from 'react';

export const RequestReviewModal = () => {
    const [reviewComment, setReviewComment] = useState<string>('');
    const { requestCampaign, setRequestCampaign, sendForReview } =
        useCampaignPlannerContext();
    const {
        project: { projectLead, dataScientist },
    } = useDashboardGlobalContext();

    const onClose = () => {
        setRequestCampaign(null);
        setReviewComment('');
    };
    const showDialog = !!requestCampaign?.id;
    const projectContacts = useMemo(() => {
        if (!dataScientist) return projectLead.displayName;

        if (projectLead.email === dataScientist.email) {
            return projectLead.displayName;
        }

        return `${projectLead.displayName} and ${dataScientist.displayName}`;
    }, [dataScientist, projectLead.displayName, projectLead.email]);

    const onSubmit = async () => {
        await sendForReview({ comment: reviewComment });
        setReviewComment('');
    };

    return (
        <Modal dismissible show={showDialog} onClose={onClose}>
            <Modal.Header>Request Data Scientist Review</Modal.Header>

            <Modal.Body className="text-white">
                <Typography variant="bodyS" className="mb-2">
                    This feature is of additional cost.
                </Typography>

                <Typography variant="bodyS" className="mb-2">
                    Would you like to proceed and contact {projectContacts} for
                    a review regarding: <b>{requestCampaign?.name}</b> with
                    budget of:{' '}
                    <b>{formatNumber(requestCampaign?.budget || 0)} EUR</b> and
                    period of:{' '}
                    <b>
                        {formatDate(
                            requestCampaign?.startDate || new Date(),
                            DateFormat.Normal,
                        )}
                    </b>{' '}
                    -{' '}
                    <b>
                        {formatDate(
                            requestCampaign?.endDate || new Date(),
                            DateFormat.Normal,
                        )}
                    </b>
                </Typography>

                <div className="col-span-2">
                    <Typography variant="bodyS" className="mb-2">
                        Leave comment for data scientist (Optional)
                    </Typography>
                    <Textarea
                        name="comment"
                        value={reviewComment}
                        onChange={(e) => {
                            setReviewComment(e.target.value);
                        }}
                    />
                </div>
            </Modal.Body>

            <Modal.Footer className="py-4">
                <Button
                    className="ml-2"
                    size="sm"
                    color="light"
                    onClick={onSubmit}
                >
                    Send for review
                </Button>
                <Button
                    className="ml-2"
                    size="sm"
                    color="red"
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
